import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'

async function start() {
  // Modalità demo (solo `npm run demo`): va installata prima di creare il client Supabase
  if (import.meta.env.VITE_DEMO_MODE === 'true') {
    await import('./demo/install')
    const { DemoBanner } = await import('./demo/DemoBanner')
    const el = document.createElement('div')
    document.body.appendChild(el)
    createRoot(el).render(<DemoBanner />)
  }
  const { App } = await import('./app/App')
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
}

void start()
